import { useEffect, useRef } from 'react';

/**
 * A textarea that automatically resizes to fit its content.
 */
export function TextArea(props) {
    const { value, onChange, ...rest } = props;
    const ref = useRef(null);

    useEffect(() => {
        if (ref.current) {
            ref.current.style.height = 'auto';
            ref.current.style.height = `${ref.current.scrollHeight}px`;
        }
    }, [value]);

    return <textarea ref={ref} value={value} onChange={onChange} {...rest} />;
}
